// extracted by mini-css-extract-plugin
var _1 = "i9E2TALUKQ9OZ4opPRJu";
var _2 = "ypGvLGpc3bzuFnxSLWgA";
var _3 = "wvBzG36F9oUelHm3kyH7";
var _4 = "b2higuiZmmRa3jRxPOP1";
var _5 = "jJUuibyyo8crREgHF_Fe";
export { _1 as "chip", _2 as "icon", _3 as "politikerBrand", _4 as "publikBrand", _5 as "text" }
